<template>
  <div v-if="obra" class="mt-2">
    <v-row :class="{ 'flex-column-reverse': vuetify?.breakpoint.smAndDown }">
      <v-col cols="12">
        <v-row dense>
          <Info cols="6" label="Localização" :value="obra.deLocalizacao" />
          <Info cols="6" label="Título" :value="obra.deTituloSubtitulo" />
          <Info
            cols="6"
            label="Título anterior/posterior"
            :value="obra.deTituloSubtituloAnteriorList"
          />
          <Info cols="6" label="Sigla" :value="obra.deSigla" />
          <Info
            cols="6"
            label="Publicações"
            :value="formatarPublicacoes(obra.obraEditoraList)"
          />
          <Info cols="6" label="Data inicial" :value="obra.deDataInicial" />
          <Info cols="6" label="Data final" :value="obra.deDataFinal" />
          <Info cols="6" label="ISSN" :value="obra.cdIssn" />
          <Info cols="6" label="Periodicidade" :value="obra.dePeriodicidade" />
          <Info cols="6" label="Conteúdo" :value="obra.deConteudo" />
          <Info
            cols="6"
            label="Disponibilidade"
            :value="obra.deDisponibilidade"
          />

          <v-col cols="12">
            <TabelaArtigos />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row dense>
      <Info
        cols="12"
        highlighted
        hide-bullet-point
        header="Notas Gerais"
        :value="obra.notaList"
      />
      <Info cols="12" highlighted header="Assunto(s)" :value="obra.assuntos" />

      <v-col cols="12">
        <TabelaLocalizacao
          v-if="obra.localizacaoList"
          class="mt-1 mb-2"
          :items="obra.localizacaoList"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import Info from '@/components/DynamicInfo.vue';
import TabelaLocalizacao from './TabelaLocalizacao.vue';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';
import { storeToRefs } from 'pinia';
import { useVuetify } from '@/composables/useVuetify';
import { formatarPublicacoes } from '@/utils/util';
import TabelaArtigos from './TabelaArtigos.vue';

const vuetify = useVuetify();
const store = ConsultaObrasStore();
const { obraTempImpressao: obra } = storeToRefs(store);
</script>
